import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginParams } from 'app/model/authen/authen';
import { Observable } from 'rxjs/Observable';
import { CLIENT_ID, Language } from 'app/model/constant';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { accountFrontend } from 'environments/properties';
import { AppConfigService } from '../app-config/app-config.service';

@Injectable()
export class ExtraGuard implements CanActivate {

  public loginParams = new LoginParams();

  constructor(
    private utilitiesService: UtilitiesService,
    private authService: AuthenticationService,
    private router: Router,
    private appConfigService: AppConfigService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (state.url.includes('/action') && state.root.queryParams.action && state.root.queryParams.lang) {
      const authorizeRequest = this.authService.generateAuthorizeRequest();
      authorizeRequest.lang = state.root.queryParams.lang;
      const queryString = this.utilitiesService.objectToQueryString({
        action: state.root.queryParams.action,
        ...authorizeRequest
      });
      const redirectURI = `${accountFrontend}${queryString}`;
      window.location.href = encodeURI(redirectURI);

    } else if (state.url.includes('/redirect') && state.root.queryParams.code && state.root.queryParams.state) {
      this.loginParams.code = state.root.queryParams.code;
      this.loginParams.state = state.root.queryParams.state;

      this.authService.loginFromAccount(this.loginParams.state, this.loginParams.code).subscribe(res => {
        if (res) {
          const returnUrl: string = this.appConfigService.getReturnUrl() || '/';
          const returnUrlTree: UrlTree = this.router.parseUrl(returnUrl);
          if (!('lang' in returnUrlTree.queryParams)) {
            returnUrlTree.queryParams['lang'] = this.appConfigService.getLanguage();
          }
          this.appConfigService.removeReturnUrlCookie();
          this.router.navigateByUrl(returnUrlTree.toString());
        } else {
          this.router.navigate([]);
        }
      }, (error) => {
        console.log(error);
        this.router.navigate([]);
      });

    }
    else if (state.url.includes('/b2c/login')) {
      const lang = state.root.queryParams.lang ? state.root.queryParams.lang : Language.th;
      this.login(lang, CLIENT_ID.B2C.toString());
    }
    else if (state.url.includes('/login')) {
      const lang = state.root.queryParams.lang ? state.root.queryParams.lang : Language.th;
      this.login(lang, CLIENT_ID.ASCENDTRAVEL.toString());

    } else if (state.url.includes('/joinus')) {
      const lang = state.root.queryParams.lang ? state.root.queryParams.lang : Language.th;
      this.joinUs(lang);

    } else {
      return true;
    }
  }

  login(lang: string, clietId: string) {
    let queryParams: any = this.authService.generateAuthorizeRequest(undefined, clietId);
    queryParams = {
      ...queryParams,
      lang: lang
    }
    window.location.href = encodeURI(`${accountFrontend}${this.utilitiesService.objectToQueryString(queryParams)}`);
  }

  joinUs(lang: string) {
    const queryParams = {
      page: 'joinUs',
      ...this.authService.generateAuthorizeRequest(),
      lang: lang
    };
    window.location.href = encodeURI(`${accountFrontend}${this.utilitiesService.objectToQueryString(queryParams)}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guard/extra.guard.ts